import { render, staticRenderFns } from "./infoItem.vue?vue&type=template&id=59866d0e&"
import script from "./infoItem.vue?vue&type=script&lang=js&"
export * from "./infoItem.vue?vue&type=script&lang=js&"
import style0 from "./infoItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports